module.exports = __webpack_public_path__ + "img/電気回路_1_9_2.b4c8ca49.png";